export default __webpack_public_path__ + "static/media/Walker's Jerkin of the Far Horizon.b0a364b2.jpg";